import React from 'react';
import { BUTTON_STYLES } from 'constants/styles';
import SubstitutionBadge from './SubstitutionBadge';

const GarnishSubstitutionSection = ({ order, orderIndex, onToggleGarnish, isLocked, saving, autoSubstitution }) => {
    if (!order.garnishOptions || order.garnishOptions.length === 0) {
        return null;
    }

    const showAutoSubBadge = autoSubstitution?.addedId &&
        order.garnishOptions.some(opt => opt.id === autoSubstitution.addedId && opt.isActive);

    return (
        <div style={{ marginBottom: '15px' }}>
            <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#555'
            }}>
                Garnish:
                {showAutoSubBadge && (
                    <SubstitutionBadge
                        removedName={autoSubstitution.removedName}
                        addedName={autoSubstitution.addedName}
                    />
                )}
            </label>
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px'
            }}>
                {order.garnishOptions.map((garnishOption, index) => {
                    const isActive = garnishOption.isActive;
                    const isDisabled = isLocked || saving;
                    const subs = (garnishOption.subIngredientNames || []).map(s => (s || '').replace(/^SF /, ''));
                    const title = subs.length > 0 ? `${garnishOption.name}: ${subs.join(', ')}` : undefined;

                    return (
                        // Tooltip lives on this wrapper, not the button — Chromium
                        // won't show a title tooltip on a disabled button.
                        <span key={index} title={title}>
                            <button
                                onClick={() => onToggleGarnish && onToggleGarnish(orderIndex, garnishOption.id, isActive)}
                                disabled={isDisabled}
                                style={BUTTON_STYLES.substitution(isActive, isDisabled)}
                                data-testid={`garnish-option-${garnishOption.id}`}
                            >
                                <span style={{
                                    marginRight: '4px',
                                    fontSize: '12px'
                                }}>
                                    {isActive ? '✓' : '+'}
                                </span>
                                {garnishOption.name}
                            </button>
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

export default GarnishSubstitutionSection;